import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetInvoiceEnhancedCsvMovesQueryVariables = Types.Exact<{
  moveIds: Array<Types.Scalars['bigint']['input']> | Types.Scalars['bigint']['input'];
}>;


export type GetInvoiceEnhancedCsvMovesQuery = { __typename?: 'query_root', moves: Array<{ __typename?: 'moves', id: number, reference_num?: string | null, vehicle_vin?: string | null, vehicle_stock?: string | null, status?: string | null, cancel_status?: string | null, move_type: string, consumer_type?: string | null, customer?: { __typename?: 'customers', id: number, name?: string | null } | null, lane?: { __typename?: 'lanes', id: number, description?: string | null, distance_miles?: number | null } | null }> };


export const GetInvoiceEnhancedCsvMovesDocument = gql`
    query GetInvoiceEnhancedCsvMoves($moveIds: [bigint!]!) {
  moves(where: {id: {_in: $moveIds}}) {
    id
    reference_num
    vehicle_vin
    vehicle_stock
    status
    cancel_status
    move_type
    consumer_type
    customer {
      id
      name
    }
    lane {
      id
      description
      distance_miles
    }
  }
}
    `;

/**
 * __useGetInvoiceEnhancedCsvMovesQuery__
 *
 * To run a query within a React component, call `useGetInvoiceEnhancedCsvMovesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceEnhancedCsvMovesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceEnhancedCsvMovesQuery({
 *   variables: {
 *      moveIds: // value for 'moveIds'
 *   },
 * });
 */
export function useGetInvoiceEnhancedCsvMovesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceEnhancedCsvMovesQuery, GetInvoiceEnhancedCsvMovesQueryVariables> & ({ variables: GetInvoiceEnhancedCsvMovesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceEnhancedCsvMovesQuery, GetInvoiceEnhancedCsvMovesQueryVariables>(GetInvoiceEnhancedCsvMovesDocument, options);
      }
export function useGetInvoiceEnhancedCsvMovesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceEnhancedCsvMovesQuery, GetInvoiceEnhancedCsvMovesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceEnhancedCsvMovesQuery, GetInvoiceEnhancedCsvMovesQueryVariables>(GetInvoiceEnhancedCsvMovesDocument, options);
        }
// @ts-ignore
export function useGetInvoiceEnhancedCsvMovesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceEnhancedCsvMovesQuery, GetInvoiceEnhancedCsvMovesQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceEnhancedCsvMovesQuery, GetInvoiceEnhancedCsvMovesQueryVariables>;
export function useGetInvoiceEnhancedCsvMovesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceEnhancedCsvMovesQuery, GetInvoiceEnhancedCsvMovesQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceEnhancedCsvMovesQuery | undefined, GetInvoiceEnhancedCsvMovesQueryVariables>;
export function useGetInvoiceEnhancedCsvMovesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceEnhancedCsvMovesQuery, GetInvoiceEnhancedCsvMovesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceEnhancedCsvMovesQuery, GetInvoiceEnhancedCsvMovesQueryVariables>(GetInvoiceEnhancedCsvMovesDocument, options);
        }
export type GetInvoiceEnhancedCsvMovesQueryHookResult = ReturnType<typeof useGetInvoiceEnhancedCsvMovesQuery>;
export type GetInvoiceEnhancedCsvMovesLazyQueryHookResult = ReturnType<typeof useGetInvoiceEnhancedCsvMovesLazyQuery>;
export type GetInvoiceEnhancedCsvMovesSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceEnhancedCsvMovesSuspenseQuery>;
export type GetInvoiceEnhancedCsvMovesQueryResult = Apollo.QueryResult<GetInvoiceEnhancedCsvMovesQuery, GetInvoiceEnhancedCsvMovesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/invoices/queries/getInvoiceEnhancedCsvMoves.query.gql}
 */
export async function getInvoiceEnhancedCsvMoves(
  variables: GetInvoiceEnhancedCsvMovesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetInvoiceEnhancedCsvMovesQuery['moves']>
export async function getInvoiceEnhancedCsvMoves(
  variables: GetInvoiceEnhancedCsvMovesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetInvoiceEnhancedCsvMovesQuery>
export async function getInvoiceEnhancedCsvMoves(
  variables: GetInvoiceEnhancedCsvMovesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetInvoiceEnhancedCsvMovesQuery['moves'] | GetInvoiceEnhancedCsvMovesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetInvoiceEnhancedCsvMovesQuery>(
    GetInvoiceEnhancedCsvMovesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves
}